import React, { useState } from 'react';
import { toast } from 'sonner';
import { ThumbsDown, ThumbsUp } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

// Fidem aprende: the lawyer rates each answer; "not useful" notes are fed back into Fidem's next answers
export const FidemFeedback = ({ sid, idx, initial, prefix = 'fidem' }) => {
  const { api } = useAuth();
  const [fb, setFb] = useState(initial || null);
  const [asking, setAsking] = useState(false);
  const [note, setNote] = useState('');
  const send = async (useful, n = '') => {
    try { setFb((await api.post(`/fidem/sessions/${sid}/feedback/${idx}`, { useful, note: n || null })).data.feedback); setAsking(false); toast.success('Gracias: Fidem lo tendrá en cuenta'); } catch { toast.error('No se pudo guardar'); }
  };
  if (fb) return <p data-testid={`${prefix}-feedback-done-${idx}`} className="mt-2 text-[11px] text-slate-500">{fb.useful ? 'Marcada como útil' : `Marcada como no útil${fb.note ? `: «${fb.note}»` : ''}`}</p>;
  return (
    <div className="mt-2">
      <div className="flex items-center gap-2 text-[11px] text-slate-500">
        ¿Te sirvió?
        <button aria-label="Respuesta útil" data-testid={`${prefix}-feedback-up-${idx}`} onClick={() => send(true)} className="rounded p-1 hover:bg-slate-800 hover:text-emerald-300"><ThumbsUp className="h-3.5 w-3.5" /></button>
        <button aria-label="Respuesta no útil" data-testid={`${prefix}-feedback-down-${idx}`} onClick={() => setAsking(true)} className="rounded p-1 hover:bg-slate-800 hover:text-rose-300"><ThumbsDown className="h-3.5 w-3.5" /></button>
      </div>
      {asking && (
        <div className="mt-1 flex gap-2">
          <input data-testid={`${prefix}-feedback-note-${idx}`} value={note} onChange={(e) => setNote(e.target.value)} placeholder="¿Qué faltó o estuvo mal? (opcional)" className="min-w-0 flex-1 rounded-lg border border-slate-700 bg-slate-950 px-2 py-1 text-xs text-slate-200" />
          <button data-testid={`${prefix}-feedback-send-${idx}`} onClick={() => send(false, note)} className="rounded-lg bg-rose-600 px-2 text-xs text-white">Enviar</button>
        </div>
      )}
    </div>
  );
};
